
      import Sad from './sad.vue'
      import type { App, Plugin } from 'vue'

      export const SadPlugin: Plugin = {
        install(app: App) {
          app.component('Sad', Sad)
        },
      }
      export { Sad }
      